import { createAction } from '@ngrx/store';

export const EmptyAction = createAction('[Billing Widget Alert] Empty Action');
